module.exports = __webpack_public_path__ + "static/media/iyzico-3.7a6eab9a.png";